//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import search from "@/mixins/search";
import Plan from "@/models/Plan";
import isMobile from "~/mixins/isMobile.js";

export default {
  mixins: [search, isMobile],
  props: {
    headline: {
      required: false,
      default: false,
    },
    description: {
      required: false,
      default: false,
    },
    price: {
      required: false,
      default: false,
    },
    cta: {
      required: false,
      default: false,
    },
    ctaLink: {
      required: false,
      default: false,
    },
    mainCTAs: {
      required: false,
      default: false,
    },
    color: {
      required: false,
      default: "navy",
    },
    mobileFlex: {
      required: false,
      default: "tw-flex-col",
    },
    hideImageOnMobile: {
      required: false,
      default: false,
    },
    textColor: {
      required: false,
      default: "white",
    },
    isPlusAd: {
      required: false,
      default: false,
    },
    businessCta: {
      required: false,
      default: false,
    },
    paCtas: {
      required: false,
    },
    epCta: {
      required: false,
      default: false,
    },
    disclaimer: {
      required: false,
      default: false,
    },
  },
  data() {
    return {
      plansLoaded: false,
    };
  },
  methods: {
    handleShowSearch() {
      if (this.isMobile) this.$nuxt.$emit("activateMobileSearch");
      else this.$nuxt.$emit("activateSearch");
    },
  },
  computed: {
    plans() {
      return this.$store
        .$db()
        .model("plans")
        .query()
        .first();
    },
    annualPlan() {
      if (this.plans && this.plans.annual_plan)
        return {
          ...this.plans.annual_plan,
          dollars: (this.plans.annual_plan.price_cents / 100).toFixed(),
          cents: this.plans.annual_plan.price_cents
            .toString()
            .substring(
              this.plans.annual_plan.price_cents.toString().length - 2
            ),
          monthly_price: (this.plans.annual_plan.price_cents / 1200).toFixed(2),
        };
    },
  },
  created() {
    if (this.isPlusAd)
      Plan.fetchAll().then((_) => {
        this.plansLoaded = true;
      });
  },
};
